// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./img/exportdownload.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("./img/user-icon-light.svg", import.meta.url);
// Module
var code = `<!-- header.html -->
<div class="container">
  <div class="container-left">
    <div class="crumbbar">
      <!-- dropdown crumbbar(s) here -->
    </div>
  </div>
  <div class="container-right">
    <hs-rounded-button id="export-data-button" icon="${___HTML_LOADER_IMPORT_0___}" class="hide" title="Export" action="hs-export-data"></hs-rounded-button>
    <div id="header-menu-wrapper" class="menu-wrapper menu-wrapper-sidebar hide">
      <button id="menu-button" class="menu-button settings-menu-button" type="button" aria-haspopup="menu" aria-expanded="false" aria-label="User preferences menu">
        <img src="${___HTML_LOADER_IMPORT_1___}" data-icon-light="./img/user-icon-light.svg" data-icon-blue="./img/user-icon-blue.svg" class="menu-avatar-icon" alt="User preferences">
      </button>
      <div id="menu-dropdown" class="menu-dropdown hide" role="menu">
        <div id="menu-user-info" class="menu-user-info" role="presentation">
          <div class="menu-user-label">Signed in as</div>
          <div id="menu-user-name" class="menu-user-name">Unknown user</div>
          <div id="menu-user-type" class="menu-user-pill" aria-label="User type">User Type: Unknown</div>
          <div id="menu-version" class="menu-version hide"></div>
        </div>
        <button id="menu-status" class="menu-item menu-status ops-status-badge hide" type="button" role="menuitem" title="">
          <span id="menu-status-dot" class="ops-status-dot"></span>
          <span id="menu-status-text" class="ops-status-text">Status: Loading</span>
        </button>
        <button id="menu-explore" class="menu-item hide" type="button" role="menuitem">Explore</button>
        <button id="menu-live-logs" class="menu-item hide" type="button" role="menuitem">Live Logs</button>
        <button id="menu-pipeline-sandbox" class="menu-item hide" type="button" role="menuitem">Pipeline Sandbox</button>
        <button id="menu-service-monitor" class="menu-item hide" type="button" role="menuitem">Service Monitor</button>
        <button id="menu-my-dashboard" class="menu-item" type="button" role="menuitem">My Dashboard</button>
        <button id="menu-default-dashboard" class="menu-item" type="button" role="menuitem">Default View</button>
        <button id="menu-edit-mode" class="menu-item hide" type="button" role="menuitem">Edit Layout</button>
        <button id="menu-send-feedback" class="menu-item" type="button" role="menuitem">Send Feedback</button>
        <button id="menu-upgrade" class="menu-item hide" type="button" role="menuitem">Upgrade Service</button>
        <button id="menu-reset-dashboard" class="menu-item menu-item-danger" type="button" role="menuitem">Reset to Default</button>
      </div>
    </div>
  </div>
</div>

<div id="feedback-modal" class="feedback-modal hide" role="dialog" aria-modal="true" aria-labelledby="feedback-title">
  <div id="feedback-backdrop" class="feedback-backdrop"></div>
  <div class="feedback-panel">
    <div class="feedback-header">
      <div id="feedback-title" class="feedback-title">Send Feedback</div>
      <button id="feedback-close" type="button" class="feedback-close" aria-label="Close">×</button>
    </div>
    <div class="feedback-body">
      <label class="feedback-label" for="feedback-category">Category</label>
      <select id="feedback-category" class="feedback-select">
        <option value="ui-layout">UI / Layout</option>
        <option value="data-issue">Data Issue</option>
        <option value="chart-idea">Chart Idea</option>
        <option value="feature-request">Feature Request</option>
        <option value="bug">Bug</option>
        <option value="other">Other</option>
      </select>

      <label class="feedback-label" for="feedback-title-input">Title (optional)</label>
      <input id="feedback-title-input" class="feedback-input" type="text" maxlength="160" placeholder="Short summary" />

      <label class="feedback-label" for="feedback-message">Message</label>
      <textarea id="feedback-message" class="feedback-textarea" maxlength="4000" placeholder="Describe the issue, suggestion, or request..."></textarea>

      <div id="feedback-status" class="feedback-status" aria-live="polite"></div>
    </div>
    <div class="feedback-actions">
      <button id="feedback-cancel" type="button" class="feedback-btn feedback-btn-secondary">Cancel</button>
      <button id="feedback-submit" type="button" class="feedback-btn feedback-btn-primary">Submit</button>
    </div>
  </div>
</div>

<div id="upgrade-modal" class="upgrade-modal hide" role="dialog" aria-modal="true" aria-labelledby="upgrade-title">
  <div id="upgrade-backdrop" class="feedback-backdrop"></div>
  <div class="upgrade-panel">
    <div class="feedback-header">
      <div id="upgrade-title" class="feedback-title">Upgrade Service</div>
      <button id="upgrade-close" type="button" class="feedback-close" aria-label="Close">×</button>
    </div>
    <div class="feedback-body">
      <div id="upgrade-current-info" class="upgrade-info"></div>

      <label class="feedback-label" for="upgrade-branch">Branch</label>
      <div class="upgrade-branch-row">
        <select id="upgrade-branch" class="feedback-select upgrade-branch-select" disabled>
          <option disabled selected>Loading branches…</option>
        </select>
        <input id="upgrade-branch-custom" class="feedback-input upgrade-branch-input hide" type="text" placeholder="branch name" maxlength="128" />
        <button id="upgrade-branch-toggle" type="button" class="upgrade-branch-toggle" title="Toggle custom input">✎</button>
      </div>

      <div id="upgrade-status" class="feedback-status" aria-live="polite"></div>
      <div id="upgrade-log" class="upgrade-log hide"></div>
    </div>
    <div class="feedback-actions">
      <button id="upgrade-cancel" type="button" class="feedback-btn feedback-btn-secondary">Cancel</button>
      <button id="upgrade-submit" type="button" class="feedback-btn feedback-btn-primary">Build &amp; Deploy</button>
    </div>
  </div>
</div>
`;
// Exports
export default code;